/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_Menu_Api_BaglantilariInputs */

const tr_mesafeli_menu_api_baglantilari = /** @type {(inputs: Mesafeli_Menu_Api_BaglantilariInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayarlar > API Bağlantıları`)
};

const en_mesafeli_menu_api_baglantilari = /** @type {(inputs: Mesafeli_Menu_Api_BaglantilariInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings > API Connections`)
};

const de_mesafeli_menu_api_baglantilari = /** @type {(inputs: Mesafeli_Menu_Api_BaglantilariInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen > API-Verbindungen`)
};

const ru_mesafeli_menu_api_baglantilari = /** @type {(inputs: Mesafeli_Menu_Api_BaglantilariInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки > API-подключения`)
};

/**
* | output |
* | --- |
* | "Settings > API Connections" |
*
* @param {Mesafeli_Menu_Api_BaglantilariInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_menu_api_baglantilari = /** @type {((inputs?: Mesafeli_Menu_Api_BaglantilariInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_Menu_Api_BaglantilariInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_menu_api_baglantilari(inputs)
	if (locale === "de") return de_mesafeli_menu_api_baglantilari(inputs)
	if (locale === "ru") return ru_mesafeli_menu_api_baglantilari(inputs)
	return tr_mesafeli_menu_api_baglantilari(inputs)
});